export class CodesFileModel {
    procedure_no: number
    procedure_clinic: number
    code_no: number
    code_type: number
    code_name: string
    code_active: string
    code_specie: number
    code_approval: string
    code_fix: string
    code_modified_date: string
    code_category: string
    code_sub_category: string
    brief_history_category: string
    code_clinic: number
    procedure_desc: string
    type: string

    constructor(
        procedure_no: number,
        procedure_clinic: number,
        code_no: number,
        code_type: number,
        code_name: string,
        code_active: string,
        code_specie: number,
        code_approval: string,
        code_fix: string,
        code_modified_date: string,
        code_category: string,
        code_sub_category: string,
        brief_history_category: string,
        code_clinic: number,
        procedure_desc: string,
        type: string
    ) {
        this.procedure_no = procedure_no
        this.procedure_clinic = procedure_clinic
        this.code_no = code_no
        this.code_type = code_type
        this.code_name = code_name
        this.code_active = code_active
        this.code_specie = code_specie
        this.code_approval = code_approval
        this.code_fix = code_fix
        this.code_modified_date = code_modified_date
        this.code_category = code_category
        this.code_sub_category = code_sub_category
        this.brief_history_category = brief_history_category
        this.code_clinic = code_clinic
        this.procedure_desc = procedure_desc
        this.type = type
    }
}